import { Link } from "react-router-dom";
import { Users, Briefcase, Snowflake, Cog } from "lucide-react";
import { API } from "@/lib/api";

const resolveUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http") || u.startsWith("data:")) return u;
  const base = API.replace(/\/api$/, "");
  return u.startsWith("/api/") ? `${base}${u}` : u;
};

export default function VehicleCard({ v }) {
  return (
    <div className="piki-card overflow-hidden flex flex-col" data-testid="vehicle-card-item">
      <div className="relative h-52 sm:h-56 w-full bg-[#0A0A0A] overflow-hidden">
        <img
          src={resolveUrl(v.primary_image)}
          alt={v.name}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
          loading="lazy"
        />
        <span className="absolute top-4 left-4 bg-[#050505]/80 backdrop-blur-md text-[#D9A62E] border border-[#D9A62E]/30 text-[10px] px-3 py-1 rounded-full font-mono-piki font-semibold uppercase tracking-wider">
          {v.category}
        </span>
        {!v.available && (
          <span className="absolute top-4 right-4 bg-[#EF4444]/90 text-white text-[10px] px-3 py-1 rounded-full font-semibold uppercase">Unavailable</span>
        )}
      </div>

      <div className="p-6 flex-1 flex flex-col">
        <h3 className="font-display font-bold text-xl text-white leading-tight" data-testid="vehicle-card-title">{v.name}</h3>
        <p className="text-xs text-[#A3A3A3] mt-1">{v.tagline}</p>

        <div className="grid grid-cols-4 gap-2 py-4 border-y border-[#2E2E2E] my-4 text-center text-[11px] text-[#A3A3A3]">
          <div className="flex flex-col items-center gap-1"><Users className="w-4 h-4 text-[#D9A62E]" /><span>{v.passengers} pax</span></div>
          <div className="flex flex-col items-center gap-1"><Briefcase className="w-4 h-4 text-[#D9A62E]" /><span>{v.luggage}</span></div>
          <div className="flex flex-col items-center gap-1"><Cog className="w-4 h-4 text-[#D9A62E]" /><span>{v.transmission.split(" ")[0]}</span></div>
          <div className="flex flex-col items-center gap-1"><Snowflake className="w-4 h-4 text-[#D9A62E]" /><span>{v.ac ? "A/C" : "—"}</span></div>
        </div>

        <div className="flex items-end justify-between mt-auto">
          <div>
            <div className="text-2xl font-extrabold text-[#D9A62E] font-mono-piki" data-testid="vehicle-card-rate-text">
              ${v.daily_rate}
            </div>
            <div className="text-[10px] uppercase tracking-widest text-[#737373] font-mono-piki">per day</div>
          </div>
        </div>

        <div className="flex items-center gap-2 mt-5">
          <Link
            to={`/fleet/${v.id}`}
            className="flex-1 text-center piki-outline-btn text-sm py-2.5"
            data-testid="vehicle-card-view-details-btn"
          >
            Details
          </Link>
          <Link
            to={`/book?vehicle=${v.id}`}
            className="flex-1 text-center piki-gold-btn text-sm py-2.5"
            data-testid="vehicle-card-book-now-btn"
          >
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
}
